<template>

	<!-- 新闻资讯 -->
	<section class="section">
		<div class="container">
			<div class="section-title">
				<h2>最新资讯</h2>
				<p>了解行业动态和公司最新信息</p>
			</div>
			<div class="news-grid">
				<div class="news-card">
					<div class="news-image">
						<img src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
							alt="财税新闻">
					</div>
					<div class="news-content">
						<span class="news-date">2024-12-09</span>
						<a href="#" class="news-title">重新整理公司服务项目</a>
						<p class="news-excerpt">今天对公司的服务项目进行了重新整理，有需求可以联系我们。</p>
					</div>
				</div>
				<div class="news-card">
					<div class="news-image">
						<img src="https://images.unsplash.com/photo-1554224155-6726b3ff858f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
							alt="财税政策">
					</div>
					<div class="news-content">
						<span class="news-date">2024-11-20</span>
						<a href="#" class="news-title">最新税收优惠政策解读</a>
						<p class="news-excerpt">针对最新出台的税收优惠政策，为企业提供专业解读和应用指导。</p>
					</div>
				</div>
				<div class="news-card">
					<div class="news-image">
						<img src="https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80"
							alt="财务规划">
					</div>
					<div class="news-content">
						<span class="news-date">2024-10-15</span>
						<a href="#" class="news-title">企业年终财务规划指南</a>
						<p class="news-excerpt">为企业提供年终财务规划的专业建议，助力企业做好年度财务总结。</p>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>